import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilePdf,
	faChartPie,
	faScroll,
	faFileArrowDown,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import SocialFeed from './SocialFeed/index.vue'

import api from '@/helpers/fetch'

library.add(faFilePdf, faChartPie, faScroll, faFileArrowDown)

@Component({
	components: {
		Loader,
		SocialFeed,
	},
})
export default class Home extends Vue {
	groups = [] as Array<any>
	loading = false

	decisionColors = {
		Deferida: 'background-green',
		'Parcialmente deferida': 'background-yellow',
		Indeferida: 'background-red',
		Desistência: 'background-purple',
		'Acórdão provido': 'background-green',
		'Acórdão parcialmente provido': 'background-yellow',
		'Acórdão não provido': 'background-red',
		'Totalmente procedente': 'background-green',
		'Parcialmente procedente': 'background-yellow',
		Improcedente: 'background-red',
		Sim: 'background-green',
		Não: 'background-red',
		'N/A': 'text-muted',
	}

	table = {
		fields: [
			{
				key: 'index',
				label: '#',
			},
			{
				key: 'subject',
				label: 'Tese',
				sortable: true,
			},
			{
				key: 'occurrences',
				label: 'Ocorrências',
				sortable: true,
				tdClass: 'text-center',
			},
		],
		items: [] as Array<any>,
	}

	async mounted() {
		this.loading = true
		const res = await api.get('/api/my-account/groups')
		this.loading = false
		if (res.ok) {
			this.groups.push(...res.data)

			const subjectsFromAllTrials = new Set(
				this.groups.reduce((subjectsFromAllTrials, group) => {
					subjectsFromAllTrials.push(
						...group.trials.reduce((subjectsList, trial) => {
							if (trial && trial.subjects) {
								subjectsList.push(
									...trial.subjects.map(
										(subject) => subject.name,
									),
								)
							}
							return subjectsList
						}, []),
					)
					return subjectsFromAllTrials
				}, []),
			)

			subjectsFromAllTrials.forEach((subject) => {
				const item = {
					subject,
					occurrences: 0,
				}

				this.groups.forEach((group) => {
					group.trials.forEach((trial) => {
						item.occurrences += trial.subjects.reduce(
							(count, trialSubject) => {
								if (trialSubject.name === subject) count++
								return count
							},
							0,
						)
					})
				})

				this.table.items.push(item)
			})
		}
	}

	get userFirstName() {
		return JSON.parse(localStorage.getItem('user')!).name.split(' ')[0]
	}

	isBlankOrHidden(decision) {
		if (!decision) return true

		decision = decision.toLowerCase()
		return decision === 'oculto' || decision === 'em branco'
	}

	getLastDecision(trial) {
		if (!this.isBlankOrHidden(trial.decisionHabilitacaoDeCredito)) {
			return trial.decisionHabilitacaoDeCredito
		} else if (!this.isBlankOrHidden(trial.decisionTransitoEmJulgado)) {
			return trial.decisionTransitoEmJulgado
		} else if (!this.isBlankOrHidden(trial.decisionStf)) {
			return trial.decisionStf
		} else if (!this.isBlankOrHidden(trial.decisionStj)) {
			return trial.decisionStj
		} else if (!this.isBlankOrHidden(trial.decisionTj)) {
			return trial.decisionTj
		} else if (!this.isBlankOrHidden(trial.decisionTrf)) {
			return trial.decisionTrf
		} else if (!this.isBlankOrHidden(trial.decisionSentenca)) {
			return trial.decisionSentenca
		} else if (!this.isBlankOrHidden(trial.decisionLiminar)) {
			return trial.decisionLiminar
		} else return null
	}

	getLastDecisionInstance(trial) {
		if (!this.isBlankOrHidden(trial.decisionHabilitacaoDeCredito)) {
			return 'Habilitação de Crédito'
		} else if (!this.isBlankOrHidden(trial.decisionTransitoEmJulgado)) {
			return 'Trânsito Em Julgado'
		} else if (!this.isBlankOrHidden(trial.decisionStf)) {
			return 'STF'
		} else if (!this.isBlankOrHidden(trial.decisionStj)) {
			return 'STJ'
		} else if (!this.isBlankOrHidden(trial.decisionTj)) {
			return 'TJ'
		} else if (!this.isBlankOrHidden(trial.decisionTrf)) {
			return 'TRF'
		} else if (!this.isBlankOrHidden(trial.decisionSentenca)) {
			return 'Sentença'
		} else if (!this.isBlankOrHidden(trial.decisionLiminar)) {
			return 'Liminar'
		} else return null
	}

	getSet(subjects) {
		if (subjects && subjects.length) {
			return new Set(subjects.map((subject) => subject.name))
		}

		return null
	}

	get trialsCount() {
		return this.groups.reduce((sum, group) => sum + group.trials.length, 0)
	}

	get subjectsSet() {
		// comment
		return new Set(
			this.groups.reduce((subjectsFromAllTrials, group) => {
				subjectsFromAllTrials.push(
					...group.trials.reduce((subjectsList, trial) => {
						if (trial.subjects && trial.subjects.length) {
							subjectsList.push(
								...trial.subjects.map(
									(subject) => subject.name,
								),
							)
						}

						return subjectsList
					}, []),
				)
				return subjectsFromAllTrials
			}, []),
		)
	}

	get reportVisibleByGroupId() {
		const result = {}
		this.groups.forEach((group) => {
			const allHaveCompanies = group.trials.every((trial) => {
				if (trial && trial.clients && trial.clients.length) {
					return true
				}

				return false
			})

			result[group.id] = allHaveCompanies
		})

		return result
	}

	formatDate(date) {
		return date.split('-').reverse().join('/')
	}

	async downloadFile($event, file) {
		const googleDriveId = file.googleDriveId
		const res = await fetch(
			'/api/decision-files/download?googleDriveId=' + googleDriveId,
			{
				headers: {
					Accept: 'application/pdf',
					'Content-Type': 'application/pdf',
				},
				method: 'GET',
				credentials: 'include',
			},
		)

		const headers = [...res.headers]
		const contentDispositionHeader = headers.find(
			(array) => array[0] === 'content-disposition',
		)
		if (contentDispositionHeader) {
			const fileName = contentDispositionHeader[1].replace(
				'attachment; filename=',
				'',
			)

			const blob = await res.blob()
			const newBlob = new Blob([blob])
			const blobUrl = window.URL.createObjectURL(newBlob)

			const link: any = document.createElement('a')
			link.href = blobUrl
			link.setAttribute('download', fileName)
			document.body.appendChild(link)

			if (link) {
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(blobUrl)
			}
		}
	}
}
